import { Button } from "@mui/material";
import { ReactNode } from "react";
import { sxTextButton } from "./sxProps";

interface TextButtonProps {
  endIcon?: any;
  startIcon?: any;
  iconStart?: any;
  sx?: any;
  children: ReactNode;
  onClick: (e: React.MouseEvent<HTMLButtonElement, MouseEvent>) => void;
  className?: string;
}

function TextButton({
  endIcon,
  startIcon,
  children,
  onClick,
  sx,
}: Readonly<TextButtonProps>) {
  return (
    <Button sx={{ ...sxTextButton, ...sx }} onClick={onClick}>
      {startIcon && (
        <img
          src={startIcon}
          alt="Ícone de botão"
          width={"19px"}
          height={"19px"}
        />
      )}
      {children}
      {endIcon && (
        <img
          src={endIcon}
          alt="Ícone de botão"
          width={"14px"}
          height={"14px"}
        />
      )}
    </Button>
  );
}

export default TextButton;
